/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const EdibleLiquid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Edible liquid"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#4485DA"
        d="M1.368 3.314A2 2 0 0 1 3.343 1h17.314a2 2 0 0 1 1.975 2.314l-2.864 18A2 2 0 0 1 17.793 23H6.207a2 2 0 0 1-1.975-1.686z"
        className="Main"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        d="M4.216 8.556a1 1 0 0 1 1.237-1.113l.661.17a5.1 5.1 0 0 0 3.642-.43 5.1 5.1 0 0 1 4.541-.107l.25.117a5.65 5.65 0 0 0 3.982.308l.038-.011a.96.96 0 0 1 1.218 1.059l-1.562 10.739A2 2 0 0 1 16.243 21H7.757a2 2 0 0 1-1.98-1.712z"
        className="Details"
      />
      <path
        fill="#4485DA"
        d="M8.687 11.184a.997.997 0 0 1 1.36-.362l.713.41c.476.274.64.88.364 1.354l-.412.71a.997.997 0 0 1-1.359.363l-.714-.41a.99.99 0 0 1-.364-1.354zm-.146 3.806a.995.995 0 0 1 1.219.7l.213.793a.99.99 0 0 1-.703 1.213l-.797.213a.995.995 0 0 1-1.218-.7l-.214-.793a.99.99 0 0 1 .704-1.214zm3.135 1.888a.997.997 0 0 1 1.36-.362l.713.41c.476.274.64.88.364 1.354l-.412.71a.997.997 0 0 1-1.359.363l-.714-.41a.99.99 0 0 1-.364-1.354z"
        className="Main"
      />
    </g>
  </svg>
);

export const EdibleLiquidIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'edible-liquid-icon'}
      icon={EdibleLiquid}
      {...props}
      size={size}
    />
  );
};
